import { FC } from "react";
import styled from "styled-components";

import { SVG_MUI } from "@ryde/assets";
import { useRtl, useSelectItemsTranslate } from "@ryde/redux";
import { DirectionEnum, IStyledAttributes, removeSlash } from "@ryde/shared";

const DirectionCellStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "direction-cell",
})`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 2px;
  font-size: 14px;
  svg {
    padding-inline-start: 7px;
    cursor: pointer;
  }
`;

export interface ICellDirectionProps {
  value: DirectionEnum | string | null | undefined;
  /** RYDE-8171: meal-only shift — the meal-only pill replaces the direction pill, the A/B/AB label stays. */
  isMealOnly?: boolean;
}

export const DirectionCell: FC<ICellDirectionProps> = ({
  value,
  isMealOnly,
}): JSX.Element => {
  const { translateLabel } = useSelectItemsTranslate();
  const { direction } = useRtl();
  const displayValue =
    value === undefined || value === null || value === ""
      ? DirectionEnum.PickUp
      : value;

  return (
    <DirectionCellStyled dir={direction}>
      {isMealOnly ? (
        <SVG_MUI.OvalMeal2SVG data-e2e="svg-oval-meal-only" />
      ) : (
        <>
          {displayValue === DirectionEnum.PickUp && <SVG_MUI.OvalTo2SVG />}
          {displayValue === DirectionEnum.DropOff && <SVG_MUI.OvalBack2SVG />}
          {displayValue === DirectionEnum.Both && <SVG_MUI.OvalBoth2SVG />}
          {displayValue === DirectionEnum.None && <SVG_MUI.OvalNone2SVG />}
        </>
      )}
      {translateLabel(`Dir${removeSlash(displayValue)}`)}
    </DirectionCellStyled>
  );
};
